module.exports = __webpack_public_path__ + "static/availability-7aa7fde9ea78b6f64f3337bbb854f589.svg";